import { toast } from "react-toastify"

export const showErrorToast = (message?: string) => {
  toast.error(message || "Something went wrong. Please try again.")
}

export const showSuccessToast = (message: string) => {
  toast.success(message)
}
